var __rspack_ns_object = JSON.parse('{"Studies":"Test Studies","Measurements":"Test Measurements"}')